import React, { useState } from "react";
import { useHistory } from "react-router";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import moment from "moment";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

import SuperAdminDeleteEvent from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteEvent";
import isEmpty from "../../../store/validation/is-Empty";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewEventDetailsOffline = (props) => {
  const history = useHistory();

  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const [showView, setShowView] = useState(false);
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const handleShowView = () => {
    setShowView(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    console.log("test");
  };
  const [showLog, setShowLog] = useState(false);
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const onHandleRedirect = (data) => (e) => {
    history.push({
      pathname: `/event/edit-offline-event`,
      state: { editData: data },
    });
  };

  return (
    <>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowView}
      >
        <Image
          src={require("../../../assets/images/UserManagement/eye.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="enTabs d-flex flex-wrap align-items-center mb-4 mb-2">
            <Button
              variant="link"
              onClick={(e) => handleTab("1")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "1" ? "active" : ""
              }`}
            >
              General Information
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab("2")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "2" ? "active" : ""
              }`}
            >
              RSVP
            </Button>
            {props.vendorEvent?.ticket_booking_subscription ? (
              <Button
                variant="link"
                onClick={(e) => handleTab("3")}
                className={`px-0 mr-4 text-grayLink f15-500 ${
                  selectedTab === "3" ? "active" : ""
                }`}
              >
                Ticket Booking
              </Button>
            ) : null}
            {props.vendorEvent?.ticket_booking_subscription ? (
              <Button
                variant="link"
                onClick={(e) => handleTab("4")}
                className={`px-0 mr-4 text-grayLink f15-500 ${
                  selectedTab === "4" ? "active" : ""
                }`}
              >
                Seating
              </Button>
            ) : null}
            <Button
              variant="link"
              onClick={(e) => handleTab("5")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "5" ? "active" : ""
              }`}
            >
              Other Settings
            </Button>
          </div>
          {selectedTab === "1" && (
            <React.Fragment>
              <div className="pt-3 d-flex justify-content-between">
                <div>
                  <div className="f12-400 opacity5">Event Name</div>
                  <div className="d-flex align-items-center pt-2">
                    <div className="f16-500">
                      {props.vendorEvent && props.vendorEvent.name}
                    </div>
                    {props.vendorEvent && props.vendorEvent.isOnline ? (
                      <div className="enSuccessLBL ml-2">Online</div>
                    ) : (
                      <div className="enPendingLBL ml-2">Offline</div>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div
                    className="enIconBtn mr-3"
                    onClick={onHandleRedirect(props.vendorEvent)}
                  >
                    <Image
                      src={require("../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </div>
                  <SuperAdminDeleteEvent
                    handleCloseView={handleCloseView}
                    actionBy={"vendor"}
                    insideDelete={"viewDelete"}
                    eventId={props.vendorEvent && props.vendorEvent._id}
                  />
                </div>
              </div>
              <div className="pt-4 f12-400 opacity5">Description</div>
              <div className="pt-2 f12-400 text-break">
                {props.vendorEvent && props.vendorEvent.description}
              </div>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {props.vendorEvent && props.vendorEvent.active
                        ? "Active"
                        : "Inactive"}
                    </div>
                    {/* <Toggle
                      checked={props.vendorEvent && props.vendorEvent.active}
                      toggleFunction={toggleFunction}
                    /> */}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Primary Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {props.vendorEvent && props.vendorEvent.mark_as_primary
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Kids Allowed</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {props.vendorEvent && props.vendorEvent.isKidsAllowed
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                  {props.vendorEvent && props.vendorEvent.isKidsAllowed ? (
                    <></>
                  ) : (
                    <div className="f12-500 mr-2">
                      Min Age: {props.vendorEvent && props.vendorEvent.minAge}
                    </div>
                  )}
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Event Tags</div>
                  <div className="f16-700">
                    {!isEmpty(props.vendorEvent) &&
                      props.vendorEvent.eventTags.map((data, index) => {
                        return (
                          <React.Fragment key={index}>{data}, </React.Fragment>
                        );
                      })}
                  </div>
                </Col>
              </Row>

              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(
                        props.vendorEvent && props.vendorEvent.start_date
                      ).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(
                        props.vendorEvent && props.vendorEvent.start_date
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">End Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(
                        props.vendorEvent && props.vendorEvent.end_date
                      ).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">End Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(
                        props.vendorEvent && props.vendorEvent.end_date
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
              <div className="pt-4 f12-400 opacity5">
                Venue /Address / Location
              </div>
              <div className="pt-2 pb-4 f12-400 text-break">
                {props.vendorEvent && props.vendorEvent.venue_address}
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">View Event Image</div>
                {/* <div className="enIMG105"></div> */}
                <div className="d-flex flex-wrap">
                  <SimpleReactLightbox>
                    {(
                      (props.vendorEvent && props.vendorEvent.photos) ||
                      []
                    ).map((url, index) => (
                      <div
                        className="enIconUploaded bg-transparent"
                        key={index}
                      >
                        <SRLWrapper options={options}>
                          <Image
                            src={url}
                            alt="Document"
                            className="rounded img-thumbnail"
                            fluid
                          />
                        </SRLWrapper>
                      </div>
                    ))}
                  </SimpleReactLightbox>
                </div>
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">View Video</div>
                <div className="w-25">
                  {props?.vendorEvent?.videos === "" ||
                  props?.vendorEvent?.videos.length <= 0 ? (
                    <h5 className="f12-500">Video Not Available</h5>
                  ) : (
                    <SimpleReactLightbox>
                      <SRLWrapper options={options}>
                        <video width="100%" height="100%" controls>
                          <source
                            src={props.vendorEvent.videos?.[0]}
                            type="video/mp4"
                          />
                        </video>
                      </SRLWrapper>
                    </SimpleReactLightbox>
                  )}
                </div>
              </div>
              <div className="pb-4">
                <div className="f12-400 opacity5">Terms and Conditions</div>
                <div className="pt-2 f12-400 text-break">
                  {props.vendorEvent && props.vendorEvent.terms_and_condition}
                </div>
              </div>
            </React.Fragment>
          )}
          {selectedTab === "2" && (
            <React.Fragment>
              <Row>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">Auto Accept</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {props.vendorEvent && props.vendorEvent.isRSVP_autoAccept
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">
                    Maximum Number of Guests
                  </div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.maxGuest_RSVP}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">
                    Buffer Number of Guests
                  </div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.buffer_RSVP_guest}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">
                    Minimum number of people
                  </div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.min_people_RSVP}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 opacity5 pb-3">
                    Maximum number of people
                  </div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.max_people_RSVP}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="d-flex justify-content-end align-items-center">
                    <div
                      className="enIconBtn mr-3"
                      onClick={onHandleRedirect(props.vendorEvent)}
                    >
                      <Image
                        src={require("../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </div>
                    <SuperAdminDeleteEvent
                      handleCloseView={handleCloseView}
                      actionBy={"vendor"}
                      insideDelete={"viewDelete"}
                      eventId={props.vendorEvent && props.vendorEvent._id}
                    />
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "3" && (
            <React.Fragment>
              <hr />
              <div className="enTicketBox d-flex flex-wrap justify-content-between">
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Ticket Name</div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.ticketName}
                  </div>
                </div>
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Adult Price</div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.adult_price}
                  </div>
                </div>
                {props.vendorEvent && props.vendorEvent.isKidsAllowed ? (
                  <div className="enbox">
                    <div className="f12-500 opacity5 pb-3">Child Price</div>
                    <div className="f16-700">
                      {props.vendorEvent && props.vendorEvent.child_price}
                    </div>
                  </div>
                ) : null}
                <div className="enbox">
                  <div className="f12-500 opacity5 pb-3">Total Quantity</div>
                  <div className="f16-700">
                    {props.vendorEvent && props.vendorEvent.total_quantity_TB}
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-center">
                  <div
                    className="enIconBtn mr-3"
                    onClick={onHandleRedirect(props.vendorEvent)}
                  >
                    <Image
                      src={require("../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </div>
                  <SuperAdminDeleteEvent
                    handleCloseView={handleCloseView}
                    actionBy={"vendor"}
                    insideDelete={"viewDelete"}
                    eventId={props.vendorEvent && props.vendorEvent._id}
                  />
                </div>
              </div>
              <hr />
              <div className="enTicketBox d-flex flex-wrap">
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Minimum people per booking
                  </div>
                  <div className="f16-700">
                    {props.vendorEvent &&
                      props.vendorEvent.min_people_per_booking}
                  </div>
                </div>
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Maximum people per booking
                  </div>
                  <div className="f16-700">
                    {props.vendorEvent &&
                      props.vendorEvent.max_people_per_booking}
                  </div>
                </div>
              </div>
              <div className="f12-400 opacity5 pb-3">Ticket Description</div>
              <div className="f12-400 pb-4">
                {props.vendorEvent && props.vendorEvent.ticket_description}
              </div>
              <hr />
              <div className="f12-400 opacity5 pb-3">Refund & cancellation</div>
              <div className="f12-400 pb-4">
                {props.vendorEvent && props.vendorEvent.refund_and_cancellation}
              </div>
            </React.Fragment>
          )}
          {selectedTab === "4" && (
            <React.Fragment>
              <hr />
              <Row>
                <Col lg={8}>
                  <div className="enTicketBox d-flex flex-wrap">
                    {!isEmpty(
                      props.vendorEvent &&
                        props.vendorEvent.table_setup &&
                        props.vendorEvent.table_setup.floors
                    ) &&
                      props.vendorEvent &&
                      props.vendorEvent.table_setup &&
                      props.vendorEvent.table_setup.floors.map(
                        (data, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="enbox2">
                                  <div className="f12-500 opacity5 pb-3">
                                    Floor Number / Seating Area
                                  </div>
                                  <div className="f16-700">
                                    {data.floor_number}
                                  </div>
                                </div>
                                <div className="enbox2">
                                  <div className="f12-500 opacity5 pb-3">
                                    Section Name/Number
                                  </div>
                                  <div className="f16-700">{data.area}</div>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        }
                      )}
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="enWidth300px px-3 d-flex flex-wrap justify-content-between">
                    <button
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                    >
                      View seating map
                    </button>
                    <div className="d-flex justify-content-end align-items-center">
                      <div
                        className="enIconBtn mr-3"
                        onClick={onHandleRedirect(props.vendorEvent)}
                      >
                        <Image
                          src={require("../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </div>
                      <SuperAdminDeleteEvent
                        handleCloseView={handleCloseView}
                        actionBy={"vendor"}
                        insideDelete={"viewDelete"}
                        eventId={props.vendorEvent && props.vendorEvent._id}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === "5" && (
            <React.Fragment>
              <hr />
              <Row>
                <Col lg={12}>
                  <div className="enTicketBox d-flex flex-wrap justify-content-between">
                    <div className="col-10">
                      <div className="row">
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">Highchair</div>
                          <div className="f16-700">
                            {props.vendorEvent && props.vendorEvent.highchair
                              ? "Yes"
                              : "No"}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">
                            Handicap Access
                          </div>
                          <div className="f16-700">
                            {props.vendorEvent &&
                            props.vendorEvent.handicap_access
                              ? "Yes"
                              : "No"}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">
                            Room number on Seating Request?
                          </div>
                          <div className="f16-700">
                            {props.vendorEvent &&
                            props.vendorEvent.room_on_seating_rq
                              ? "Yes"
                              : "No"}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">
                            Auto Accept Pax Limit
                          </div>
                          <div className="f16-700">
                            {props.vendorEvent &&
                              props.vendorEvent.auto_accept_pax}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex justify-content-end align-items-center">
                        <div
                          className="enIconBtn mr-3"
                          onClick={onHandleRedirect(props.vendorEvent)}
                        >
                          <Image
                            src={require("../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                        <SuperAdminDeleteEvent
                          handleCloseView={handleCloseView}
                          actionBy={"vendor"}
                          insideDelete={"viewDelete"}
                          eventId={props.vendorEvent && props.vendorEvent._id}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Event ID</div>
                  <div className="f14-400">
                    #{props.vendorEvent && props.vendorEvent._id}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(
                      props.vendorEvent && props.vendorEvent.updatedAt
                    ).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props.vendorEvent && props.vendorEvent.updatedAt
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {" "}
                    {moment(
                      props.vendorEvent && props.vendorEvent.createdAt
                    ).format("Do MMMM YYYY")}
                  </div>
                  <div className="f14-400">
                    {moment(
                      props.vendorEvent && props.vendorEvent.createdAt
                    ).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Point of Entry</div>
                  <div className="f14-400">
                    {props.vendorEvent && props.vendorEvent.point_of_entry}
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(
                    (props.vendorEvent && props.vendorEvent.auditLogs) ||
                    []
                  ).map((data, index) => (
                    <tr key={index}>
                      <td>
                        <div className="f12-500">
                          {moment(data.timestamp).format("Do MMMM YYYY")}
                        </div>
                        <div className="f12-500">
                          {moment(data.timestamp).format("hh:mm A")}
                        </div>
                      </td>
                      <td>
                        <div className="f12-500">{data.message}</div>
                      </td>
                      <td>
                        <div className="f12-500">
                          {data.initiator === "VENDOR" ? "You" : data.initiator}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewEventDetailsOffline;
